const getActiveIdentity = (context) => {
  const session = context?.activeSession;
  const drawer = context?.drawer;
  if (!session?.id) return null;
  return `${session.id}:${drawer?.id || ''}:${session.userId || ''}:${drawer?.locationId || ''}`;
};

export const getPosAccessState = ({ sessionContext, sessionContextResolved, loggedInUser, selectedLocation }) => {
  if (!sessionContextResolved) {
    return {
      canAccess: loggedInUser?.posCashDrawerStatus === 'open' && Number(loggedInUser?.posCashDrawerLocationId) === Number(selectedLocation?.id),
      drawerId: loggedInUser?.posCashDrawerID || null,
      sessionId: null,
      sequenceNo: null,
      source: 'legacy',
    };
  }

  const drawer = sessionContext?.drawer;
  const activeSession = sessionContext?.activeSession;
  const canAccess =
    drawer?.status === 'open' &&
    activeSession?.status === 'active' &&
    Number(activeSession?.userId) === Number(loggedInUser?.id) &&
    Number(drawer?.locationId) === Number(selectedLocation?.id);

  return {
    canAccess,
    drawerId: drawer?.id || null,
    sessionId: activeSession?.id || null,
    sequenceNo: activeSession?.sequenceNo || null,
    source: 'session',
  };
};

export const getPosSessionIdentifierLabel = ({ drawerId, sessionId, sequenceNo }) => {
  const identifiers = [];
  if (drawerId != null) identifiers.push(`Drawer #${drawerId}`);
  if (sessionId != null) identifiers.push(`Session #${sessionId}`);
  if (sequenceNo != null) identifiers.push(`Sequence ${sequenceNo}`);
  return identifiers.join(' · ');
};

export const getPosLifecycleTransition = (previousContext, currentContext) => {
  const previousIdentity = getActiveIdentity(previousContext);
  const currentIdentity = getActiveIdentity(currentContext);
  if (!previousIdentity || previousIdentity === currentIdentity) return null;

  return {
    activeSessionLost: !currentIdentity,
    message: currentIdentity
      ? 'Your active register session changed. POS screens were closed for safety.'
      : 'You no longer own the active register session. POS screens were closed for safety.',
  };
};
